const initialState = () => ({
  page: 1,
  // Sub-section: "upcoming" (scheduled) | "done" (already executed)
  mode: "upcoming",
  selected_tab: 0,
  // Status tab/filter param (Already Done only): "" (All) | Success | Failed | Pending
  status: "",
  // Date preset filter (Today | Yesterday | This Week | custom), both tabs.
  // Backend resolves the actual bounds; "custom" uses from_date/to_date below.
  date_preset: "",
  // Custom range: separate From and To dates (each its own calendar).
  from_date: "",
  to_date: "",
  // Dropdown filters
  product: null,
  // Loan type (Fresh Loan | Reloan | Reapplied Loan) -- options from backend.
  loan_type: null,
  payment_type: null,
  // Select-user filter: chosen borrower lead id
  lead: "",
  // Company: the borrower's employer, typed free-hand
  employer_name: "",
});

export default {
  namespaced: true,
  state: initialState(),

  mutations: {
    RESET_FILTERS(state) {
      Object.assign(state, initialState());
    },
  },
  actions: {
    resetFilters({ commit }) {
      commit("RESET_FILTERS");
    },
  },
  getters: {
    // Fresh copy of the filter defaults; used by filterChipsMixin's
    // dev coverage guard to detect applied-but-unregistered filters.
    getInitialFilters: () => initialState(),
    getFilters: (state) => {
      return state;
    },
  },
};
